// CoinContext.js
import React, { createContext, useContext, useState, useCallback } from 'react';
import { supabase } from './supabaseClient';

const CoinContext = createContext();

export function CoinProvider({ children }) {
  const [walletAddress, setWalletAddress] = useState(null);
  const [currentPoints, setCurrentPoints] = useState(0);
  const [nickname, setNickname] = useState(''); // 닉네임 추가
  const [dustPoints, setDustPoints] = useState(0); // Dust Points 추가

  // Dust Points 새로고침 함수
  const refreshDustPoints = useCallback(async () => {
    if (!walletAddress) return;

    try {
      const { data, error } = await supabase
        .from('ssii_users')
        .select('dust_points')
        .eq('wallet_address', walletAddress)
        .single();

      if (!error && data) {
        setDustPoints(data.dust_points || 0);
      }
    } catch (err) {
      console.error('Error refreshing dust points:', err);
    }
  }, [walletAddress]);

  return (
    <CoinContext.Provider value={{
      walletAddress,
      setWalletAddress,
      currentPoints,
      setCurrentPoints,
      nickname,
      setNickname,
      dustPoints,
      setDustPoints,
      refreshDustPoints
    }}>
      {children}
    </CoinContext.Provider>
  );
}

export function useCoin() {
  return useContext(CoinContext);
}
